{#if event}
  {#if progress}
    <hbox class="progressbar" style="width: {progress * 100}%" />
  {/if}
  <hbox class="time font-small">
    {duration}
  </hbox>
  <!--hbox class="debug">
    Start time {event.startTime?.toLocaleTimeString(getDateTimeLocale())}
    End time {event.endTime?.toLocaleTimeString(getDateTimeLocale())}
    Started {meeting.started?.toLocaleTimeString(getDateTimeLocale())}
    End time {meeting.ended?.toLocaleTimeString(getDateTimeLocale())}
  </hbox-->
{/if}

<script lang="ts">
  import type { VideoConfMeeting } from "../../../logic/Meet/VideoConfMeeting";
  import { getDateTimeLocale } from "../../../l10n/l10n";

  export let meeting: VideoConfMeeting;

  $: event = meeting?.event;
  $: progress = event ? meeting.started && event.startTime && event.endTime && event.endTime.getTime() - event.startTime.getTime() > 0
      ? (new Date().getTime() - event.startTime.getTime()) / (event.endTime.getTime() - event.startTime.getTime())
      : 0
    : 0;
  $: duration = calculateDuration(meeting.started);
  function calculateDuration(started: Date): string {
    if (!started) {
      return;
    }
    let dur = new Date();
    dur.setTime(dur.getTime() - meeting.started.getTime());
    console.log("dur", dur);
    duration = dur.toLocaleTimeString(getDateTimeLocale());
    setTimeout(calculateDuration, 1000);
    return duration;
  }
</script>

<style>
  .progressbar {
    border-top: 2px solid green;
    align-self: flex-start;
  }
  .time {
    align-self: flex-end;
    margin: 4px 16px -4px 0;
  }
</style>
